/* Kinexis Labs — small, dependency-free interactions. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal on scroll
  var els = document.querySelectorAll('.kx-reveal');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var d = parseInt(e.target.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { e.target.classList.add('is-in'); }, d);
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Header border once scrolled
  var header = document.querySelector('.kx-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  // Product gallery
  var main = document.querySelector('[data-kx-main]');
  document.querySelectorAll('[data-kx-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.src = btn.getAttribute('data-src');
      main.alt = btn.getAttribute('data-alt') || '';
      document.querySelectorAll('[data-kx-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');
    });
  });

  // Variant selector -> button label
  var form = document.querySelector('[data-kx-buy]');
  if (form) {
    var label = form.querySelector('[data-kx-buy-label]');
    var btn = form.querySelector('[data-kx-buy-btn]');
    var update = function () {
      var c = form.querySelector('input[name="id"]:checked');
      if (!c || !label) return;
      var available = c.getAttribute('data-available') === 'true';
      label.textContent = available ? ('Begin the Protocol · ' + c.getAttribute('data-price')) : c.getAttribute('data-waitlist-label');
      btn.setAttribute('data-mode', available ? 'buy' : 'waitlist');
    };
    form.addEventListener('change', update); update();
    form.addEventListener('submit', function (e) {
      if (btn.getAttribute('data-mode') === 'waitlist') {
        e.preventDefault();
        var w = document.getElementById('waitlist');
        if (w) { w.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); var i = w.querySelector('input[type="email"]'); if (i) setTimeout(function () { i.focus(); }, 400); }
      }
    });
  }
})();